import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('AuthCallback mounted. Hash:', window.location.hash);

        // 1. First attempt: Standard session check
        // Supabase client might have already processed the hash
        const { data: { session }, error } = await supabase.auth.getSession();
        console.log('Initial session check result:', { session, error });

        if (session) {
          console.log('Session found via getSession. Redirecting to dashboard...');
          navigate('/dashboard');
          return;
        }

        // 2. Second attempt: Manual hash parsing
        // If getSession returned null/error but we have a hash with access_token
        // This handles cases where auto-detection fails or race conditions occur
        const hash = window.location.hash;
        if (hash && hash.includes('access_token')) {
          console.log('Attempting manual token parsing from hash...');

          // Remove the leading '#' if present
          const cleanHash = hash.startsWith('#') ? hash.substring(1) : hash;
          const params = new URLSearchParams(cleanHash);

          const access_token = params.get('access_token');
          const refresh_token = params.get('refresh_token');
          const type = params.get('type');

          if (access_token) {
            console.log('Found access_token in hash. Forcing session set...');

            const { data, error: setSessionError } = await supabase.auth.setSession({
              access_token,
              refresh_token: refresh_token || '',
            });

            console.log('Manual setSession result:', { data, error: setSessionError });

            if (data.session) {
              console.log('Manual session set successful! Redirecting to dashboard...');
              navigate('/dashboard');
              return;
            } else if (setSessionError) {
              console.error('Failed to set session manually:', setSessionError);
            }
          } else {
            console.warn('Hash present but no access_token found inside it.');
          }
        } else {
          console.log('No hash with access_token found.');
        }

        // If we reached here, authentication failed
        console.error('Authentication failed: No session and manual parsing failed.');
        // Optional: show an error message to user instead of immediate redirect
        // navigate('/'); 
      } catch (error) {
        console.error('Auth callback exception:', error);
        navigate('/');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: '18px',
      color: '#333'
    }}>
      Autenticando...
    </div>
  );
};

export default AuthCallback;
